import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Shield } from "lucide-react";
import { toast } from "sonner";
import Header from "../components/common/Header";
import SecurityMessage from "../components/common/SecurityMessage";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

const ADMIN_CODE = "ADMIN9680";

const AdminLoginPage = ({ onAdminLogin }) => {
  const [code, setCode] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsLoading(true);

    setTimeout(() => {
      if (code === ADMIN_CODE) {
        onAdminLogin();
        toast.success("Connexion admin réussie !");
        navigate("/admin/dashboard");
      } else {
        toast.error("Code administrateur invalide");
      }
      setIsLoading(false);
    }, 1000);
  };

  return (
    <div className="min-h-screen flex flex-col">
      <Header minimal />
      
      <div className="flex-1 flex items-center justify-center px-6 py-12 bg-slate-50">
        <div className="w-full max-w-md">
          <div className="bg-white rounded-xl border border-slate-200 shadow-sm p-8">
            <div className="text-center mb-8">
              <div className="bg-primary/10 rounded-full w-16 h-16 flex items-center justify-center mx-auto mb-4">
                <Shield className="h-8 w-8 text-primary" />
              </div>
              <h1 className="text-2xl font-semibold text-primary mb-2">Espace Administrateur</h1>
              <p className="text-slate-600">
                Accès réservé aux administrateurs ECOPAY
              </p>
            </div>

            <form onSubmit={handleSubmit} className="space-y-6">
              <div className="space-y-2">
                <Label htmlFor="adminCode">Code administrateur</Label>
                <Input
                  id="adminCode"
                  type="password"
                  placeholder="Entrez votre code admin"
                  value={code}
                  onChange={(e) => setCode(e.target.value)}
                  required
                  data-testid="admin-code-input"
                  className="h-11"
                />
              </div>

              <Button
                type="submit"
                className="w-full h-11 bg-primary hover:bg-primary/90"
                disabled={isLoading}
                data-testid="admin-login-btn"
              >
                {isLoading ? "Connexion en cours..." : "Se connecter"}
              </Button>
            </form>
          </div>

          <SecurityMessage />
        </div>
      </div>
    </div>
  );
};

export default AdminLoginPage;
